import type { TransitionableStateValue } from "@/entities/state";

import { useBatchTransitionRowContext } from "@/modules/batch-transition/batch-transition.hook";

export const useBatchTransitionRow = (state: TransitionableStateValue) => {
  const { type, rowCount, rowItems } = useBatchTransitionRowContext(state);
  const noNextStates = !rowItems[0].next_states.length;

  return {
    type,
    count: rowCount,
    noNextStates,
  };
};
